import { Reservation, ReservationStatus, VenueListReservationsFilter } from '../../graphql/API';
import { executeGql, processGqlResult } from '../../utils/gql-utils';

const statuses = Object.values(ReservationStatus).filter(
  (reservation) => reservation !== ReservationStatus.past,
);

const venueListReservationsQuery = /* GraphQL */ `
  query venueListReservations($filter: VenueListReservationsFilter!) {
    venueListReservations(filter: $filter) {
      items {
        actionDate
        canSubmitRequirements
        checkInDateTime
        createdAt
        updatedAt
        id
        instagramTag
        marketID
        marketName
        name
        noShowStatus
        note
        offerCategory
        offerEndTime
        offerID
        offerStartTime
        offerTitle
        offerValue
        effectiveStartDateTime
        reservationDate
        status
        timeZoneId
        userID
        user {
          firstname
          lastname
          tags
        }
        userPicture {
          thumbnail
          small
        }
        venueID
        venueName
        validation
        postOnInstagramFeed
        postOnInstagramStories
        postOnInstagramStories2x
        postOnInstagramStories3x
        postOnInstagramReels
        postOnTikTokVideo
        privateOffer
        postLink
        offerConfirmWithCall
        effectiveEndDateTime
        penaltyType
        penaltyStatus
        offerPrice
        offerTimeZoneId
        paymentStatus
        paymentReadyDate
        shippingStatus
        shippedDate
        requirementsSubmitted
        inviteID
        shopifyOrder {
          orderID
          draftOrderID
          orderUrl
          status
        }
        shippingAddress {
          address1
          address2
          city
          postalCode
          stateProvince
          country
          countryCode
        }
        orderTracking {
          trackingNumber
        }
        shopifyProductID
      }
    }
  }
`;

export const venueListReservationsApi = async (
  filter: Partial<VenueListReservationsFilter>,
): Promise<Reservation[]> => {
  const { status } = filter;

  if (!status) {
    filter.status = statuses;
  }

  const result = await executeGql<Reservation[]>(venueListReservationsQuery, { filter });
  return processGqlResult<Reservation[]>('venueListReservations.items', result);
};
